import React from 'react'

const PaymentOptionsEndorsement = () => {
  return (
    <div>
      PaymentOptions
    </div>
  )
}

export default PaymentOptionsEndorsement
